const REF_KEY = 'kx_ref';
const NINETY_DAYS = 90 * 24 * 60 * 60 * 1000;
const API = process.env.REACT_APP_BACKEND_URL;

/* Capture ?ref=CODE (+ optional &ch=channel) on landing: persist 90 days + register the click. */
export function captureRef() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('ref');
    if (!code) return;
    localStorage.setItem(REF_KEY, JSON.stringify({ code: code.toUpperCase(), at: Date.now() }));
    fetch(`${API}/api/affiliates/track`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ref: code,
        page: window.location.pathname,
        ch: (params.get('ch') || '').slice(0, 30),
        referrer: (document.referrer || '').slice(0, 300),
      }),
    }).catch(() => {});
  } catch { /* ignore */ }
}

export function getRef() {
  try {
    const stored = JSON.parse(localStorage.getItem(REF_KEY) || 'null');
    if (!stored || Date.now() - stored.at > NINETY_DAYS) return null;
    return stored.code;
  } catch {
    return null;
  }
}
